import { render, staticRenderFns } from "./DonutChart.vue?vue&type=template&id=239af176&scoped=true&"
import script from "./DonutChart.vue?vue&type=script&lang=js&"
export * from "./DonutChart.vue?vue&type=script&lang=js&"
import style0 from "./DonutChart.vue?vue&type=style&index=0&id=239af176&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239af176",
  null
  
)

export default component.exports